import { useContext, useMemo } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { UserContext } from '@contexts/user-context';
import { observer } from 'mobx-react-lite';

import { useStores } from '@shared/hooks';
import { TextLink, getSupportMailDataValues } from '@shared/index';

import { Label } from '../agent-profile';

export const SupportLinkHint = observer(() => {
  const { t } = useTranslation();
  const { getUserName } = useContext(UserContext);
  const {
    MainStore: {
      agentContractStore: { profile },
      agentUserStore: { agent },
    },
  } = useStores();
  const username = getUserName();

  const values = useMemo(
    () =>
      getSupportMailDataValues({
        t,
        username,
        profile,
        agent,
        appealPlace: window.location.href,
      }),
    [t, username, profile, agent, window.location.href]
  );

  return (
    <Label>
      <Trans
        components={{ supportLink: <TextLink href={values.mailtoHref} /> }}
      >
        {t('AGENT_PROFILE:hints.support') + t('COMMON:mailto.body')}
      </Trans>
    </Label>
  );
});
